import React, { Component } from 'react';
import {
  EnrollIntroduction,
  EnrollSingleInput,
  EnrollSuccess
} from '@imprivata/nucleus';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as actions from '../../../actions';
import Logout from '../../shared/Logout';
import { push } from 'redux-first-history';

/**
 * SmsEnroll Component
 */
export class SmsEnroll extends Component {
  state = {
    phoneNumber: '',
    verificationCode: '',
  };
  /**
   * The allowed properties for the SmsEnroll component
   * @param {function} enrollSms enroll the given phone number for sms authentication
   * @param {function} smsEnrolled was sms enrolled successfully?
   * @param {function} enrollVerifySms verify the sms enrollment before completing enrollment
   * @param {function} inputEnrollSms begin introduction for sms enrollment
   * @param {function} editPhoneNumber change the phone number to be used
   * @param {function} backToIntroduction go back to the enrollment introduction
   * @param {function} skipEnrollment skips enrolling the imprivataId app
   * @param {function} changeEnrollModality changes the enrollment modality to be used
   * @param {bool} isLoading is something on the page loading?
   * @param {bool} primaryFactorEnrolled is a primary authentication factor enrolled already?
   * @param {number} serverStateVersion The current server state version
   * @param {array} errorCode The original error code
   * @param {array} errorMessage The array of error messages to display
   * @param {string} phoneNumber The user's phone number
   * @param {string} currentStep the current enrollment step
   * @param {bool} canSkipEnrollment can the user skip this enrollment step?
   * @param {bool} canChangeEnrollmentModality can the user change the modality to enroll?
   */
  static propTypes = {
    enrollSms: PropTypes.func.isRequired,
    smsEnrolled: PropTypes.func.isRequired,
    enrollVerifySms: PropTypes.func.isRequired,
    inputEnrollSms: PropTypes.func.isRequired,
    editPhoneNumber: PropTypes.func.isRequired,
    backToIntroduction: PropTypes.func.isRequired,
    skipEnrollment: PropTypes.func.isRequired,
    changeEnrollModality: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    primaryFactorEnrolled: PropTypes.bool,
    serverStateVersion: PropTypes.number,
    errorCode: PropTypes.string,
    errorMessage: PropTypes.array,
    phoneNumber: PropTypes.string,
    lastFourDigits: PropTypes.string,
    currentStep: PropTypes.string,
    canSkipEnrollment: PropTypes.bool,
    canChangeEnrollmentModality: PropTypes.bool,
  };
  submitIntroduction = () => {
    this.setState({ verificationCode: '', });
    this.props.inputEnrollSms();
  };
  submitInput = data => {
    this.setState({ verificationCode: '', });
    this.props.enrollSms(data.input);
  };
  editPhoneNumber = () => {
    this.setState({ verificationCode: '', });
    this.props.editPhoneNumber();
  };
  verifyInputChange = data => {
    this.setState({ verificationCode: data.input, });
  };
  submitVerify = data => {
    this.props.enrollVerifySms(data.input);
    this.setState({ verificationCode: '', });
  };
  submitSuccess = () => {
    clearTimeout(this.successWaitTimeout);
    this.props.smsEnrolled();
  };
  changeEnrollmentModality = () => {
    this.props.changeEnrollModality('iid');
  };

  handleInputChange = data => {
    this.setState({ phoneNumber: data.input, });
  };

  render() {
    const verifyText = <p>Enter the code we sent via text to the phone number <strong>{
      this.props.phoneNumber
    }</strong> to enroll in SMS as a login method</p>;
    const introTitle = this.props.primaryFactorEnrolled
      ? 'Backup method'
      : 'SMS code';
    const stepIntroduction = (
      <EnrollIntroduction
        headerTitle={introTitle}
        canSkipEnrollment={this.props.canSkipEnrollment}
        onSkipEnroll={this.props.primaryFactorEnrolled
          ? null
          : this.changeEnrollmentModality
        }
        linkText={(this.props.primaryFactorEnrolled === true || this.props.canChangeEnrollmentModality === false) ?
          null : 'Back'
        }
        canEnrollAlternativeText={(this.props.canSkipEnrollment === true) ?
          'Not now' : null
        }
        onEnrollAnother={this.props.skipEnrollment}
        setupTime='1 minute'
        setupRequirements='Your mobile phone'
        submitText='Enroll SMS'
        timerImage={require('./timer_icon.png')}
        wynImage={require('./wyn_icon.png')}
        onSubmitClicked={this.submitIntroduction}
        isLoading={this.props.isLoading}
        onLinkClicked={this.props.editPhoneNumber}
        logoutComponent={<Logout />}
      >
        {this.props.primaryFactorEnrolled ? (
          <div>
            <p className='header-description'>
              Never lose access. Add SMS as a backup login method.
            </p>
          </div>
        ) : (
          <div>
            <p className='header-description'>
              Verify your identity with a one time code delivered via SMS to your mobile phone
            </p>
          </div>
        )}
      </EnrollIntroduction>
    );
    const stepInput = (
      <EnrollSingleInput
        headerTitle='Enter phone number'
        placeholderText='e.g. (000) 000-0000'
        inputHint={''}
        standardMessage={'Standard message and data rates may apply'}
        inputType='phone'
        canEnrollAlternativeText={(this.props.canSkipEnrollment === true) ? 'Not now' : null}
        submitText='Submit'
        canSkipEnrollment={this.props.canSkipEnrollment}
        input={this.state.phoneNumber}
        onEnrollAnother={this.props.skipEnrollment}
        onLinkClicked={this.props.editPhoneNumber}
        linkText={'Back'}
        onSkipEnroll={this.props.backToIntroduction}
        onInputChange={data => this.handleInputChange(data)}
        onSubmit={this.submitInput}
        displayErrors={this.props.errorMessage}
        isLoading={this.props.isLoading}
        autoFocus={true}
        autoComplete={true}
        logoutComponent={<Logout />}
      >
        We will send a code via SMS to your phone to enroll you in SMS as a login method
      </EnrollSingleInput>
    );
    const stepVerify = (
      <EnrollSingleInput
        headerTitle='Check your phone'
        placeholderText='Verification code'
        inputType='number'
        submitText='Submit'
        input={this.state.verificationCode}
        onLinkClicked={this.props.editPhoneNumber}
        onInputChange={this.verifyInputChange}
        onSubmit={this.submitVerify}
        displayErrors={this.props.errorMessage}
        isLoading={this.props.isLoading}
        maxLength='6'
        autoFocus={true}
        autoComplete={false}
        logoutComponent={<Logout />}
      >
        {verifyText}
      </EnrollSingleInput>
    );
    const successMessage = this.props.primaryFactorEnrolled
      ? 'Use SMS any time as an alternate log in method, or to enroll a new phone in Imprivata ID.'
      : 'The next time you log in, verify your identiy with a code we send to you via SMS.';

    const stepSuccess = (
      <EnrollSuccess
        headerTitle='SMS enrolled'
        enrollImage={require('../../../images/sms_enrolled_graphic.png')}
        buttonText='Done'
        onButtonClicked={this.submitSuccess}
        isLoading={this.props.isLoading}
        logoutComponent={<Logout />}
      >
        {successMessage}
      </EnrollSuccess>
    );
    let currentStepToRender;
    switch (this.props.currentStep) {
    case 'stepInput':
      currentStepToRender = stepInput;
      break;
    case 'stepSuccess':
      if (this.props.authenticationToken != null) {
        this.successWaitTimeout = setTimeout( () => this.submitSuccess(), 50000);
      }
      currentStepToRender = stepSuccess;
      break;
    case 'stepVerify':
      currentStepToRender = stepVerify;
      break;
    case 'stepIntroduction':
      // falls through
    default:
      currentStepToRender = stepIntroduction;
    }
    return <div className='content-body'>{currentStepToRender}</div>;
  }
}


const mapStateToProps = state => {
  const {
    serverStateVersion,
    errorCode,
    errorMessage,
    isLoading,
    phoneNumber,
    currentStep,
    primaryFactorEnrolled,
    canSkipEnrollment,
    canChangeEnrollmentModality,
    authenticationToken,
    lastFourDigits,
  } = state.login;
  return {
    isLoading,
    serverStateVersion,
    errorCode,
    errorMessage,
    phoneNumber,
    currentStep,
    primaryFactorEnrolled,
    canSkipEnrollment,
    canChangeEnrollmentModality,
    authenticationToken,
    lastFourDigits,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    viewDeviceList: () => {
      dispatch(push('/devicelist') );
    },
    enrollSms: input => {
      dispatch(actions.enrollSms(input) );
    },
    enrollVerifySms: input => {
      dispatch(actions.enrollVerifySms(input) );
    },
    inputEnrollSms: () => {
      dispatch(actions.inputEnrollSms() );
    },
    smsEnrolled: () => {
      dispatch(actions.smsEnrolled() );
    },
    editPhoneNumber: () => {
      dispatch(actions.editPhoneNumber() );
    },
    backToIntroduction: () => {
      dispatch(actions.backToIntroduction() );
    },
    skipEnrollment: () => {
      dispatch(actions.skipEnrollment() );
    },
    changeEnrollModality: modality => {
      dispatch(actions.changeEnrollModality(modality) );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SmsEnroll);
